import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  EMPLOYEE_SESSION_ENDED_EVENT,
  keepEmployeeSessionAlive,
  returnToEmployeeSelection,
} from "src/utils/employeeSessionKeepAlive";

// Sustituye al antiguo cierre por inactividad (60 min): la sesión del
// empleado se mantiene y se renueva sola mientras la app esté abierta.
const CHECK_EVERY_MS = 5 * 60 * 1000;

export default function useEmployeeSessionKeepAlive() {
  const dispatch = useDispatch();

  useEffect(() => {
    const check = () => { dispatch(keepEmployeeSessionAlive()); };
    const onVisible = () => {
      if (document.visibilityState === "visible") check();
    };
    const onEnded = (e) => { dispatch(returnToEmployeeSelection(e?.detail || null)); };

    const timer = setInterval(check, CHECK_EVERY_MS);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", check);
    window.addEventListener("online", check);
    window.addEventListener(EMPLOYEE_SESSION_ENDED_EVENT, onEnded);
    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", check);
      window.removeEventListener("online", check);
      window.removeEventListener(EMPLOYEE_SESSION_ENDED_EVENT, onEnded);
    };
  }, [dispatch]);
}
